import React from 'react';
import { useSelector } from 'react-redux';

const InfoCompra = ({
  label = 'Valor Final',
  total = null,
  periocidadPago = null,
  pagEstado = 'APPROVED',
}) => {
  const { formaPago, producto, moneda, valoresPagar, metodosPago } = useSelector(
    (state: any) => state.Cotizacion.cotizacion,
  );

  const getMensajePagar = (rechazadoPendiente = false) => {
    const isPTP = formaPago.indexOf('placetopay') !== -1;

    const periocidadPago =
      producto?.periocidadPago === 'Indefinido' || producto?.periocidadPago === 'Mensual';
    //const periocidadPago = false;
    const realizaPrimerCobro = producto?.realizaPrimerCobro === '0'; // true valor de cobro 1 dolar
    const mensaje = rechazadoPendiente ? 'Valor: ' : 'Cobro realizado por: ';
    if (isPTP && periocidadPago) {
      if (realizaPrimerCobro) {
        return (
          <>
            {mensaje}
            <br />
            <h5> 1 {moneda?.sigla}</h5>
            {!rechazadoPendiente && (
              <span className="text-primary" style={{ fontSize: '14px' }}>
                {' '}
                el valor será reversado
              </span>
            )}
          </>
        );
      } else {
        return (
          <>
            {mensaje} <br />
            <h5>{valoresPagar?.total + ' ' + moneda?.sigla}</h5>
          </>
        );
      }
    } else if (isPTP && !periocidadPago) {
      return (
        <>
          {mensaje} <br />
          <br />
          <h5>{valoresPagar?.total + ' ' + moneda?.sigla}</h5>
        </>
      );
    }
  };

  return (
    <div className="col-12 text-center">
      <div className="ctn">
        <div className="circulo">
          <div className="ctn-interior">
            <div className="check">
              <strong className="text-white" style={{ fontSize: '20px' }}>
                ✓
              </strong>
            </div>
            <div className="center-text alig" style={{ alignItems: 'center' }}>
              {metodosPago === 'externa' && (
                <h6 className="font-weight-bold mt-3" style={{ fontSize: '14px' }}>
                  {label}
                </h6>
              )}
              <h6 className="font-weight-bold mt-3" style={{ fontSize: '14px' }}>
                {getMensajePagar(pagEstado === 'APPROVED' ? false : true)}
              </h6>
              {/* {total && (
                <h4 className="font-weight-bold" style={{ marginTop: '15px' }}>
                  ${total}
                </h4>
              )} */}
              {/* {periocidadPago && (
                <h6 className="text-primary" style={{ fontSize: '14px' }}>
                  {periocidadPago}
                  {getMensajePagar(pagEstado === 'APPROVED' ? false : true)}
                </h6>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoCompra;
